import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend,
} from 'chart.js';
import axios from 'axios';
import { Box, Typography, CircularProgress, Chip } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function SalesPageGraphs({ productId, productTitle, quantitySoldToday }) {
  const [inventoryData, setInventoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (productId) {
      axios
        .get(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory/${productId}`)
        .then((response) => { setInventoryData(response.data); setLoading(false); })
        .catch(() => { setError(true); setLoading(false); });
    }
  }, [productId]);

  const handleClick = () => navigate(`/todays-graphs/product/${productId}`);

  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress size={24} thickness={3} />
    </Box>
  );

  if (error) return (
    <Box sx={{ p: 2, textAlign: 'center' }}>
      <Typography variant="caption" color="error">Failed to load</Typography>
    </Box>
  );

  return (
    <Box onClick={handleClick} sx={{ cursor: 'pointer' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.75rem' }}>
          {productTitle}
        </Typography>
        <Chip
          size="small"
          label={`${quantitySoldToday} sold`}
          sx={{
            height: 20,
            fontSize: '0.65rem',
            fontWeight: 600,
            bgcolor: 'rgba(239,68,68,0.1)',
            color: '#ef4444',
            border: '1px solid rgba(239,68,68,0.2)',
          }}
        />
      </Box>
      <Line
        data={{
          labels: inventoryData.map((_, i) => `${i + 1}`),
          datasets: [{
            label: 'Inventory',
            data: inventoryData.map((entry) => entry.quantity),
            fill: false,
            borderColor: '#2383e2',
            tension: 0.3,
            pointRadius: 0,
            borderWidth: 1.5,
          }],
        }}
        options={{
          responsive: true,
          plugins: { legend: { display: false }, tooltip: { enabled: true } },
          scales: {
            x: { display: false },
            y: { beginAtZero: true, grid: { color: 'rgba(0,0,0,0.04)' }, ticks: { font: { size: 9 } } },
          },
        }}
      />
    </Box>
  );
}

export default SalesPageGraphs;
